import { render, staticRenderFns } from "./kindList.vue?vue&type=template&id=e2380306"
import script from "./kindList.vue?vue&type=script&lang=js"
export * from "./kindList.vue?vue&type=script&lang=js"
import style0 from "./kindList.vue?vue&type=style&index=0&id=e2380306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports